module.exports = __webpack_public_path__ + "static/media/mindset-large.c723fbc7.png";